import { type OptionType } from '@hivebrite/design-system/Inputs';

export const isOptionType = (value: object): value is OptionType =>
  'value' in value && 'label' in value;
